import React from "react";
import { FetchFunction } from "../FetchProvider";
import { FormattedMessage } from "react-intl";
import UserSessionDialog from "./UserSessionDialog";
import UserServiceSessionDialog from "../UserServiceSessionDialog";
import NotSetValue from "../NotSetValue";

export type UserSessionListState = {
    sessionDialogData: any;
    rows: Array<any>;
    showDialog: boolean;
};

export const fetchData = async (userSub: string, fetch: FetchFunction): Promise<Array<any>> => {
    let url = "/api/sessions";
    if (userSub) url += "?user_sub=" + userSub;
    const response = await fetch(url);
    if (response.status !== 200) {
        window.location.reload();
        return;
    }

    return await response.json();
};

export const deleteSelectedSessions = (sessions: Array<any>, fetch: FetchFunction) =>
    fetch("/api/delete-sessions", {
        method: "post",
        body: JSON.stringify(sessions),
        headers: {
            "Content-Type": "application/json",
        },
    });

export const UserSessionListDialog: React.FC<{
    open: boolean;
    data: any;
    hide: () => void;
    deleteSelectedSessions: () => void;
    disableDeleteCurrentSession: boolean;
}> = ({ open, data, hide, deleteSelectedSessions, disableDeleteCurrentSession }) => {
    if (!data) return null;

    const session = data;

    const DialogRenderer = session["type"] === "service" ? UserServiceSessionDialog : UserSessionDialog;

    return (
        <DialogRenderer
            session={session}
            show={open}
            onHide={hide}
            onDelete={deleteSelectedSessions}
            disableDeleteCurrentSession={disableDeleteCurrentSession}
        />
    );
};

export const RenderUserSessionList = ({
    Dialog,
    List,
    rowsLength,
    userSub,
}: {
    Dialog: React.ComponentType<any>;
    List: React.ComponentType<any>;
    rowsLength: number;
    userSub: string;
}) => {
    if (rowsLength === 0 && userSub) {
        return <NotSetValue label="user_session.empty_list" />;
    }

    return (
        <div>
            <Dialog />
            <List />
        </div>
    );
};
